<script lang="ts" setup>
import { ref } from '#imports';
import type { ValueType } from 'ant-design-vue/es/vc-cascader/Cascader';
import { getRegionList } from '~/api/common';

const provinceModel = defineModel('province', {
  type: String,
  default: '',
});
const cityModel = defineModel('city', {
  type: String,
  default: '',
});
const selectRef = ref<ValueType>(
  [provinceModel.value, cityModel.value].filter((val) => !!val), //如果没有设置过，这里会是一个空数组
);

type OptionType = {
  label: string;
  value: string;
  children: { label: string; value: string }[];
};

const options = ref<OptionType[]>([]);

const fetchRegionList = async () => {
  const res = await getRegionList().catch((err) => {
    console.error(err);
    return [];
  });
  const data = res;
  const opts = data.map((item) => ({
    label: item.tag,
    value: item.tag,
    children: item.children.map((child) => ({
      label: child?.tag ?? '',
      value: child?.tag ?? '',
    })),
  }));
  options.value = opts;
};
fetchRegionList();
const handleChange = (value: ValueType) => {
  provinceModel.value = value ? value[0].toString() : '';
  cityModel.value = value ? value[1].toString() : '';
};
</script>
<template>
  <a-cascader
    v-model:value="selectRef"
    popup-class-name="hetao-scrollbar"
    :options="options"
    size="large"
    :allow-clear="false"
    placeholder="请选择居住地"
    @change="handleChange"
  >
    <template v-if="$slots.suffixIcon" #suffixIcon>
      <slot name="suffixIcon"></slot>
    </template>
    <template #expandIcon> </template>
  </a-cascader>
</template>
<style scoped>
:deep(.ant-select-selector) {
  @apply !h-[52px] !rounded-[52px] border-[#E6E6E6] !px-[18px] !text-[#333];
}
:deep(.ant-select-selector .ant-select-selection-item) {
  @apply text-base !leading-[50px];
}
:deep(.ant-select-selection-placeholder) {
  @apply !h-[50px] !text-base  !leading-[50px];
}
</style>
